import { createAction } from "@reduxjs/toolkit";
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["setErrorCode"] = "cartValidationError/setErrorCode";
    ActionTypes["resetErrorCode"] = "cartValidationError/resetErrorCode";
    ActionTypes["setHadPassengerNameError"] = "cartValidationError/setHadPassengerNameError";
})(ActionTypes || (ActionTypes = {}));
export const actions = {
    setErrorCode: createAction(ActionTypes.setErrorCode, (code) => ({
        payload: { code }
    })),
    resetErrorCode: createAction(ActionTypes.resetErrorCode, () => ({
        payload: {}
    })),
    setHadPassengerNameError: createAction(ActionTypes.setHadPassengerNameError, () => ({
        payload: {}
    }))
};
